import { AsyncPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SignInFormValue } from '@checkout/util-models';
import { TestHookDirective } from '@domgen/dgx-fe-components/general';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import {
  EmailInputComponent,
  PasswordInputComponent,
} from '@domgen/dgx-fe-forms/input';
import {
  FormFieldComponent,
  FormFieldDirective,
  FormRowComponent,
  FormSubmitButtonComponent,
} from '@domgen/dgx-fe-forms/layout';
import {
  FormDisabledDirective,
  FormSubmitDirective,
} from '@domgen/dgx-fe-forms/shared';
import {
  GAContainerDirective,
  GAFormFieldDirective,
  GAFormSubmitDirective,
} from '@domgen/dgx-fe-ga';
import { QMSanitiseDirective } from '@domgen/dgx-fe-qm';
import { LandingTestHooks } from '../../models/test/landing-test-hooks.enum';
import { SignInFormBuilder } from '../../services/sign-in-form-builder/sign-in-form-builder.service';
import { SignInFormComponentService } from '../../services/sign-in-form-component/sign-in-form-component.service';

@Component({
  selector: 'checkout-sign-in-form',
  templateUrl: './sign-in-form.component.html',
  styleUrls: ['./sign-in-form.component.scss'],
  providers: [SignInFormBuilder, SignInFormComponentService],
  standalone: true,
  imports: [
    AsyncPipe,
    EmailInputComponent,
    FormDisabledDirective,
    FormFieldComponent,
    FormFieldDirective,
    FormRowComponent,
    FormSubmitButtonComponent,
    FormSubmitDirective,
    GAContainerDirective,
    GAFormFieldDirective,
    GAFormSubmitDirective,
    IconComponent,
    NgIf,
    PasswordInputComponent,
    QMSanitiseDirective,
    ReactiveFormsModule,
    TestHookDirective,
  ],
})
export class SignInFormComponent implements OnInit {
  @Output() submitted = new EventEmitter<SignInFormValue>();
  readonly testHooks = LandingTestHooks;

  constructor(readonly cs: SignInFormComponentService) {}

  ngOnInit(): void {
    this.cs.buildForm();
  }

  onFormSubmit(formValue: SignInFormValue): void {
    this.submitted.emit(formValue);
  }
}
